<template>
  <div>
    <VueFileAgent
       ref="fileAgent"
      :multiple="true"
      :deletable="true"
      :meta="true"
      :accept="acceptExt"
      :maxSize="'2048MB'"
      :maxFiles="maxFiles"
      :helpText="selectText"
      :errorText="{
        type: errorMessage,
        size: errorSize,
      }"
      :thumbnailSize="120"
      :theme="'list'"
       v-model="fileRecords"
       @select="filesSelected($event)"
       @beforedelete="onBeforeDelete($event)"
       @delete="onDelete($event)"
    ></VueFileAgent>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert';
  export default {
    // ...
    data: function(){
      return {
          fileRecords : []
        , detail      : {}
        , selectText  :  "파일을 선택해주세요"
        , errorMessage : "이 형식은 문서형식이 아닙니다."
        , errorSize   : "사이즈가 2GB가 넘습니다."
        , maxFiles    : 8
        , cnt         : 0
        , acceptExt   : '.pdf,.zip, .ppt, .pptx, .doc, .docx, .xls, .xlsx , .pdf, .hwp, .txt, .csv, .hwpx'
        , acceptArrExt: [] // acceptExt array용
      };
    }
    , props:['listdocfile','detail', 'extention']
    , mounted:function(){
        console.log(this.listdocfile);

        // 업로드 허용 확장자 추가
        if (this.extention !== null && this.extention !== undefined) {
          this.acceptExt = this.acceptExt + ', ' +  this.extention
        }

        // 확장자 array
        let ext_arr = []
        this.acceptExt.split(',').map(i => ext_arr.push(i.replaceAll('.', '').trim()))
        this.acceptArrExt = ext_arr // acceptArrExt = ['pdf', 'zip', 'ppt', 'pptx', 'doc', 'docx', 'xls', 'xlsx', 'pdf', 'hwp', 'txt', 'csv', 'hwpx', 'psd', 'ai', 'sfd', 'image/*']
    }
    , watch:{
        listdocfile:function(newVal, oldVal){
          let vm = this;
          console.log(newVal);
          if(newVal.length > 0){
            for(let i=0; i< newVal.length; i++){
              this.fileRecords.push(this.setFileRemindFromDB(newVal[i]));
              vm.cnt++;
            }
          }
       },
    }
    , methods:{
      filesSelected(evt){
        let vm = this;
        if(evt.length == 0){
        }else{
          for(let i=0; i<evt.length; i++){
            // if(evt[i].ext.indexOf('pdf') > -1 || evt[i].ext.indexOf('zip') > -1  || evt[i].ext.indexOf('ppt') > -1   || evt[i].ext.indexOf('pptx') > -1  ||
            //   evt[i].ext.indexOf('doc') > -1 || evt[i].ext.indexOf('docx') > -1 || evt[i].ext.indexOf('xls') > -1   || evt[i].ext.indexOf('xlsx') > -1  ||
            //   evt[i].ext.indexOf('pdf') > -1 || evt[i].ext.indexOf('hwp') > -1  || evt[i].ext.indexOf('hwpx') > -1  || evt[i].ext.indexOf('txt') > -1   ||
            //   evt[i].ext.indexOf('csv') > -1
            // ){
            if (    this.acceptArrExt.includes(evt[i].ext) // 허용된 확장자이거나
                || (this.acceptArrExt.includes('image/*') && evt[i].file.type.indexOf('image') > -1) // 이미지 허용하는데 이미지 파일이거나
            ){
              vm.cnt++;
              vm.getUploadFiles(evt[i],vm.cnt);
            } else {
              return;
            }
          }
        }
      },
      onBeforeDelete(fileRecord){
        let vm = this;
        if(confirm('삭제하시겠습니까')){
          if(fileRecord.file == null){
            let _inner = $("#fileKey").val();
            let _key = $("#fileKey").val();
            for(let i=0; i<this.fileRecords.length; i++){
              if(this.fileRecords[i].filePath === fileRecord.filePath){
                let _path = fileRecord.filePath.split("/");
                let _cnt = i+1;
                vm.getDelete(_cnt, _path[3], "new", fileRecord.fileKey);
              }
            }
          } else{
            // if(fileRecord.ext.indexOf('pdf') > -1 || fileRecord.ext.indexOf('zip') > -1  || fileRecord.ext.indexOf('ppt') > -1 || fileRecord.ext.indexOf('pptx') > -1 ||
            //   fileRecord.ext.indexOf('doc') > -1 || fileRecord.ext.indexOf('docx') > -1 || fileRecord.ext.indexOf('xls') > -1 || fileRecord.ext.indexOf('xlsx') > -1 ||
            //   fileRecord.ext.indexOf('pdf') > -1 || fileRecord.ext.indexOf('hwp') > -1  || fileRecord.ext.indexOf('txt') > -1 || fileRecord.ext.indexOf('csv') > -1  ||
            //   fileRecord.ext.indexOf('hwpx') > -1
            // ){
            if (  this.acceptArrExt.includes(fileRecord.ext) // 허용된 확장자이거나
              || (this.acceptArrExt.includes('image/*') && fileRecord.file.type.indexOf('image') > -1) // 이미지 허용하는데 이미지 파일이거나
            ){
              for(let i=0; i<this.fileRecords.length; i++){
                if(this.fileRecords[i].file.name === fileRecord.file.name){
                  let _cnt = i+1;
                  vm.getDelete(_cnt, fileRecord.file.name, "org");
                }
              }
            }
          }
          this.$refs.fileAgent.deleteFileRecord(fileRecord);
        }
      },
      getDelete(_cnt, _name, type, fileKey){
        let vm = this;
        let _form = new FormData();
        let _inner = (fileKey != null) ? fileKey : $("#fileKey").val();
        let _key = $("#fileKey").val();
        let usrKey = $("#usrKey").val();
        _form.append('paramUid', usrKey);
        _form.append('paramText', _name);
        _form.append('resultData', _cnt);
        _form.append('defaultView', _inner);
        _form.append('statusCode', type);

        Axios.post("/api/doc/delete", _form, { headers: { 'Content-Type': 'multipart/form-data' }
        }).then(function(response) {
          vm.cnt--;
        }).catch(function(ex) {
          console.log(ex);
        });
      },
      setFileRemindFromFile(_data){
          return  {
              name : _data.file.name,
              sizeText :_data.sizeText,
              size : _data.size,
              type : _data.type,
              ext : _data.ext,
              width : _data.dimensions.width,
              height : _data.dimensions.height,
              color : _data.color
           };

        }
        ,setFileRemindFromDB(_data){
          let tmp = {
            name : _data.file_org_name,
            sizeText :_data.sizeText,
            size : _data.size,
            type : _data.filetype,
            ext : _data.fileExt,
            filePath: '/doc/' + _data.file_new_name.substring(0,8) + "/" + _data.file_new_name,
            // url: "http://localhost:8080/doc/" + _data.file_new_name.substring(0,8) + "/" + _data.file_new_name,
            url: "/doc/" + _data.file_new_name.substring(0,8) + "/" + _data.file_new_name,
            fileKey: _data.cmm_sprt,
            //urlResized: _data.imgBase64,
            lastModified: 1583992794341
          };
          return tmp;
        },
        getUploadFiles(evt, cnt){
          let vm = this;
          let _inner = $("#fileKey").val();
          let _key = $("#fileKey").val();
          let _form = new FormData();
          let _data = vm.setFileRemindFromFile(evt);

          let _param = _data;

          _form.append('uploadFiles', evt.file);
          _form.append('paramText', _key);
          _form.append('resultData', vm.cnt);
          _form.append('defaultView', _inner);
          _form.append('paramOption', JSON.stringify(_param));
          _form.append('specialType', this.detail);

          Axios.post("/api/doc/upload", _form, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function(response) {
            let result = response.data.result;
            if(result == '-999'){
              swal({
                title      : '파일 등록 실패',
                text       : '파일등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                icon       : vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  cancel: {
                    text: "Cancel",
                    value: false,
                    visible: false,
                  },
                  confirm: {
                    text: "Ok",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode : true
              }).then(result => {
                if(result){
                  for(let i = 0 ; i < vm.cnt ; i++){
                    vm.$refs.fileAgent.deleteFileRecord(evt);
                  }
                }
              });
            }
          }).catch(function(ex) {
            console.log(ex);
          });
        }
        , onDelete(evt){
        }

        , onMaxChange(max){
            this.maxFiles = max;
        },
        //alert 이미지 호출
        fnOnLoadSwalImageData:function(value){
            let _icon = "/design/common/images/sub/img_alert_"+value+".png";
            return _icon;
        },
    }
  }
</script>
